<mat-accordion [multi]="multi">
  <mat-expansion-panel
    #panel
    *ngFor="let group of accordionGroups; let i = index"
    [expanded]="multi === true ? group.expanded : i === 0"
    [class.show-warn]="showWarning(group)"
    [attr.help-key]="accordionHelp[group.name]?.key"
    (opened)="accordionClicked()"
    (closed)="accordionClicked()"
    [@.disabled]="chromeVersion > -1 && chromeVersion < 88"
  >
    <mat-expansion-panel-header>
      <mat-panel-title>
        <mat-icon color="warn" matTooltip="Invalid question values"
          >warning</mat-icon
        >
        <span>{{ group.text }}</span>
        <button
          mat-icon-button
          *ngIf="hasHelp(group)"
          class="help-icon"
          (stopPropClick)="helpIconClick(group)"
        >
          <mat-icon
            *ngIf="!!accordionHelp[group.name].svgIcon; else standard_icon"
            [svgIcon]="accordionHelp[group.name].svgIcon"
          ></mat-icon>
          <ng-template #standard_icon>
            <mat-icon>{{
              accordionHelp[group.name].icon ?? 'help_outline'
            }}</mat-icon>
          </ng-template>
        </button>
      </mat-panel-title>
    </mat-expansion-panel-header>

    <ng-container *ngFor="let question of group.questions">
      <configuration-question
        [question]="question"
        *ngIf="question.visible"
        [layout]="layoutConfig"
        [autoFocus]="setAutoFocus(question)"
        (locationUpdated)="locationUpdatedEvent($event)"
        (answered)="questionAnswered()"
        (validChanged)="validChanged(question, $event)"
      ></configuration-question>
    </ng-container>
  </mat-expansion-panel>
</mat-accordion>
